'use client'
import { useState } from 'react';
// import { title } from "@/app/[lang]/components/primitives";
import { Input, Textarea, Button, Switch } from "@nextui-org/react";

export default function FeedbackPage() {
	const [agreed, setAgreed] = useState(false);
	return (
		<div className="isolate px-6 py-14 sm:py-14 lg:px-8">
			<div
				aria-hidden="true"
				className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
			>
				<div
					style={{
						clipPath:
							'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
					}}
					className="relative left-1/2 -z-10 aspect-[1155/678] w-[36.125rem] max-w-none -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-40rem)] sm:w-[72.1875rem]"
				/>
			</div>

			<div className="mx-auto text-center mb-24 dark:text-gray-300 ">
				<h2 className="text-balance text-4xl font-semibold tracking-tight  sm:text-5xl up">Feedback</h2>
				<p className="mt-2 text-lg/8 max-w-xl">Payment agency. Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs.</p>
			</div>

			
			<form action="#" method="POST" className="mx-auto mt-16 max-w-xl sm:mt-20">
				<div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
					<div>
						<Input variant="bordered" type="text" name='first-name' label="first name" isRequired placeholder="Enter your first name" />
					</div>
					<div>
						<Input variant="bordered" type="text" name='last-name' label="last name" isRequired placeholder="Enter your last name" />
					</div>
					<div className="sm:col-span-2">
						<Input variant="bordered" type="text" name='company' label="Company" isRequired placeholder="Enter your company name" />
					</div>

					<div className="sm:col-span-2">
						<Input variant="bordered" type="email" name='email' label="Email" isRequired placeholder="Enter your email" />
					</div>
					<div className='sm:col-span-2'>
						<Input variant="bordered" type="phone" name='phone' label="Phone" isRequired placeholder="Enter your phone" />
					</div>

					<div className='sm:col-span-2'>
						<Textarea variant="bordered" type="multiline" name='message' label="Message" isRequired placeholder="Enter your message" />
					</div>

					<div className="flex gap-x-4 sm:col-span-2">

						<div className="sm:col-span-2">
							<Switch isSelected={agreed} onValueChange={setAgreed} size="sm">
								By selecting this, you agree to our{' '}
								<a href="#" className="font-semibold text-indigo-600">
									privacy&nbsp;policy
								</a>
								.
							</Switch>
						</div>

					</div>

				</div>
				<div className="mt-10">
					<Button
						type="submit"
						className="block w-full"
						color='primary'
					>
						Send message
					</Button>
				</div>
			</form>
		</div>
	);
}
